import { render, staticRenderFns } from "./MarkAsLostAssets.vue?vue&type=template&id=378f35d3"
import script from "./MarkAsLostAssets.vue?vue&type=script&lang=js"
export * from "./MarkAsLostAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports